import { StrapiBlocks } from "@/src/component/partial/StrapiBlocks";
import { StrapiComponentType, ComponentType } from "@/src/type";

import { SectionModule } from "../component";

import styles from "./ContentBlocks.module.scss";

interface ContentBlocksProps extends ComponentType.DynamicPageSectionComponentProps<StrapiComponentType.Section.ContentBlocks> {}

function ContentBlocks({ section, slug, snapToGrid, classes, searchParams, quality, layout, lazy }: ContentBlocksProps) {
  const contentBlocks: StrapiComponentType.Section.ContentBlocks = section.type?.[0];

  return (
    <SectionModule
      section={section}
      slug={slug}
      classes={{
        section: classes?.section,
        styledContainer: styles.styledContainer,
      }}
      layout={layout}
      stylePrefix="ContentBlocks"
      styleContainerId={contentBlocks.id}
      snapToGrid={snapToGrid}
      searchParams={searchParams}
      quality={quality}
      lazy={lazy}
    >
      <StrapiBlocks content={contentBlocks.content} />
    </SectionModule>
  );
}

export default ContentBlocks;
